<template>
  <!-- Forgot password page -->
  <v-container class="fill-height" fluid style="overflow-x: hidden">
    <v-row justify="center" align="center">
      <v-snackbar
        :color="snackbarColor"
        v-model="snackbar"
        top
        timeout="9000"
        transition="slide-y-transition"
        >{{ snackbarMsg }}</v-snackbar
      >
      <v-card
        max-width="350"
        tile
        flat
        class="text-center pa-3"
        color="transparent"
      >
        <!-- Enter email here -->
        <v-form v-model="valid" ref="form" @submit.prevent="onSendLink">
          <v-row>
            <v-col cols="12" class="text-uppercase mb-3 sokoPrimary--text">
              <h2>Forgot Password</h2>
            </v-col>

            <v-col cols="12">
              <v-text-field
                placeholder="Enter your email"
                name="email"
                outlined
                rounded
                :rules="[rules.required, rules.email]"
                v-model="email"
              ></v-text-field>
            </v-col>

            <v-col cols="12" v-if="sent">
              <small class="grey--text"
                >If you did not receive any email, you can resend the link
                in</small
              >
              <h1
                :class="{
                  'grey--text': timerVal <= 0,
                  'sokoDeep--text': timerVal > 0,
                }"
              >
                00:{{ timerStr }}
              </h1>
            </v-col>

            <v-col>
              <v-btn
                color="sokoPrimary white--text"
                x-large
                block
                rounded
                depressed
                :disabled="!valid"
                type="submit"
                :loading="loading"
                >{{ btnText }}</v-btn
              >
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import base64url from "base64url";
import { uuid } from "vue-uuid";

export default {
  name: "Forgot",
  data: () => ({
    email: "", // user email
    valid: true, // form validity

    btnText: "Send Link", // btn text
    loading: false, // loading animation

    sent: false, // email was successfully sent
    timerVal: 0, // timer
    snackbar: false, // snackbar display
    snackbarMsg: "Error!", // snackbar message
    status: 400, // request status
    connError: false, // internet connection error

    rules: {
      // form validation rules
      required: (v) => !!v || "Required.",
      email: (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    },
  }),
  methods: {
    async onSendLink() {
      this.loading = true;

      const sep = ";";
      const t = "skc";
      const b = {
        reqtk: base64url.encode(
          uuid.v4() + sep + this.email + sep + t + sep + uuid.v4()
        ),
      };

      const res = await fetch(
        "https://api-endpoints-sokodelivery.herokuapp.com/auth/forgot-password",
        {
          method: "POST",
          mode: "cors",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(b),
        }
      ).catch(() => {
        this.connError = true;
        return false;
      });

      console.log(res);
      this.loading = false;

      this.status = res.status;
      this.snackbar = true;

      if (this.connError) {
        this.sent = false;
        this.btnText = "Try again";
        this.snackbarMsg =
          "There was a problem establishing connection with the SokoDelivery server. Please check your internet connection and try again later!";
        this.connError = false;

        return;
      }
      const jsonBody = await res.json();

      if (res.ok) {
        // was able to reach the server
        this.sent = true;
        this.btnText = "Resend Link";
        this.startCountdown();
      } else {
        // was not able to reach the server possibly because of no internet connection
        this.sent = false;
        this.btnText = "Try again";
      }
      this.snackbarMsg = jsonBody.message;
    },

    startCountdown() {
      // countdown animation
      this.valid = false;
      this.timerVal = 44;

      const countdown = setInterval(() => {
        if (this.timerVal > 0) this.timerVal--;
      }, 1000);

      setTimeout(() => {
        clearInterval(countdown);
        this.valid = true;
      }, 45000);
    },
  },
  computed: {
    snackbarColor() {
      return this.status >= 200 && this.status <= 299 ? "error" : "error";
    },
    timerStr() {
      return this.timerVal <= 9 ? 0 + "" + this.timerVal : this.timerVal;
    },
  },
};
</script>

<style></style>
